import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import PermissionWrapper from "../PermissionWrapper";
import LoadingScreen from "../LoadingScreen";
import { getFirstAllowedRoute } from "../../utils/permission";

/**
 * Guard de rota (react-router v7): renderizado como element de <Route>,
 * devolve o componente da página ou redireciona para login/403.
 */
const AuthRoute = ({ permissions = null, auth = false, component: Component }) => {
    const location = useLocation();
    const authenticated = useSelector((state) => state.session.authenticated);
    const permissionsFromUser = useSelector((state) => state.user.permissions);
    const permissionsLoaded = useSelector((state) => state.user.permissionsLoaded);
    const company = useSelector((state) => state.user.company);

    if (location.pathname === "/") {
        if (!authenticated) {
            return <Navigate to="/login" replace />;
        }
        // Empresa/permissões ainda carregando (ex.: logo após o callback de
        // login) — segura o redirect para não decidir com dados incompletos.
        // As duas requisições correm em paralelo (initializeApp): se a de
        // empresas chegar primeiro, o array de permissões ainda vazio não
        // casaria com nenhuma rota e o usuário caía em /perfil mesmo tendo
        // dashboard.
        if (!company || !permissionsLoaded) {
            return <LoadingScreen />;
        }
        return <Navigate to={getFirstAllowedRoute(permissionsFromUser, company.unitId)} replace />;
    }

    if (!auth) {
        return <Component />;
    }

    if (authenticated) {
        if (permissions) {
            return (
                <PermissionWrapper permissions={permissions}>
                    <Component />
                </PermissionWrapper>
            );
        }
        return <Component />;
    }

    return <Navigate to="/login" replace />;
};

export default AuthRoute;
